// extracted by mini-css-extract-plugin
module.exports = {"heart-icon-btn":"iconBtns_heart-icon-btn__HHugZ"};